import { publicApiAuthScopeSchema } from "@redotech/redo-public-common/public-api-auth";
import * as z from "zod";

export const apiTokenSchema = z.object({
  id: z.bigint(),
  name: z.string(),
  /** Last few characters of the token, for display (e.g. "••••a1b2"). */
  tokenSuffix: z.string(),
  /** Non-secret display prefix (e.g. "redo_sk_"); null for migrated legacy
   *  tokens, which are shown without a prefix and marked "Imported". */
  tokenPrefix: z.string().nullable(),
  scopes: z.array(publicApiAuthScopeSchema),
  createdAt: z.date(),
  lastUsedAt: z.date().nullable(),
  revokedAt: z.date().nullable(),
  createdBy: z.string().nullable(),
});

export type ApiToken = z.infer<typeof apiTokenSchema>;
